export const PHONE_TYPES = ["mobile", "work", "home", "fax", "other"] as const
export type PhoneType = (typeof PHONE_TYPES)[number]

export interface PhoneNumber {
  id: string
  guid: string
  unformatted_phone: string
  extension?: string | null
  phone_type: PhoneType
  is_primary: boolean
  created_at: Date
  updated_at: Date
  _destroy: boolean
}
